import { gql } from '@apollo/client'

import { RESERVATION_FRAGMENT } from '../../fragments'

export const CANCEL_RESERVATION = gql`
  mutation CancelReservation($id: ID!) {
    cancelReservation(input: { id: $id }) {
      ...ReservationFields
    }
  }
  ${RESERVATION_FRAGMENT}
`
